import React from 'react';
import { formatCurrency } from '../../utils/calculations';
interface TotalsPanelProps {
  subtotal: number;
  taxAmount: number;
  taxRate: number;
  taxLabel?: string;
  shippingCharge?: number;
  discount?: number;
  fee?: number;
  feeLabel?: string;
  total: number;
}
export function TotalsPanel({
  subtotal,
  taxAmount,
  taxRate,
  taxLabel,
  shippingCharge = 0,
  discount = 0,
  fee = 0,
  feeLabel,
  total
}: TotalsPanelProps) {
  // Default tax label: "Tax (X%)" or just "Tax" if rate is 0
  const displayTaxLabel = taxLabel || (taxRate > 0 ? `Tax (${(taxRate * 100).toFixed(0)}%)` : 'Tax');
  // Default fee label
  const displayFeeLabel = feeLabel || 'Fee';
  return <div className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-239">
      <div className="flex justify-between text-sm" data-id="element-240">
        <span className="text-gray-600" data-id="element-241">Subtotal</span>
        <span className="font-medium text-gray-900" data-id="element-242">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {shippingCharge > 0 && <div className="flex justify-between text-sm" data-id="element-243">
          <span className="text-gray-600" data-id="element-244">Shipping</span>
          <span className="font-medium text-gray-900" data-id="element-245">
            {formatCurrency(shippingCharge)}
          </span>
        </div>}

      {taxAmount > 0 && <div className="flex justify-between text-sm" data-id="element-246">
          <span className="text-gray-600" data-id="element-247">{displayTaxLabel}</span>
          <span className="font-medium text-gray-900" data-id="element-248">
            {formatCurrency(taxAmount)}
          </span>
        </div>}

      {fee > 0 && <div className="flex justify-between text-sm" data-id="element-249">
          <span className="text-gray-600" data-id="element-250">{displayFeeLabel}</span>
          <span className="font-medium text-gray-900" data-id="element-251">
            {formatCurrency(fee)}
          </span>
        </div>}

      {discount > 0 && <div className="flex justify-between text-sm" data-id="element-252">
          <span className="text-gray-600" data-id="element-253">Discount</span>
          <span className="font-medium text-green-600" data-id="element-254">
            -{formatCurrency(discount)}
          </span>
        </div>}

      <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-255">
        <div className="flex justify-between" data-id="element-256">
          <span className="text-base font-semibold text-gray-900" data-id="element-257">Total</span>
          <span className="text-base font-bold text-gray-900" data-id="element-258">
            {formatCurrency(total)}
          </span>
        </div>
      </div>
    </div>;
}